import React, { useState, useContext, useCallback, useRef, useEffect } from "react";
import { NavLink } from "react-router-dom";
import Select from "react-select";
import Moment from "react-moment";
//pages & includes
import ManageSidebar from "../ManageSidebar";

//functions
import {
  _t,
  getCookie,
  modalLoading,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//3rd party packages
import { Helmet } from "react-helmet";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ExportToCsv } from "export-to-csv";
import { FaFileExport, FaFileImport, FaCloudUploadAlt, FaTimes } from 'react-icons/fa';
import Switch from "react-switch";


//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { FoodContext } from "../../../../../contexts/Food";
import DataTable from "../../../../common/DataTable";
import { ToastError, ToastSuccess } from "../../../../../functions/ToastShow";

const ViewRecipe = () => {
  const { t } = useTranslation();
  //getting context values here
  let {
    //common
    loading,
    setLoading,
  } = useContext(SettingsContext);

  let {
    //recipes
    recipeList,
    setRecipeList,
    setPaginatedRecipeList,
    recipeForSearch,
    setRecipeForSearch,
    //pagination
    dataPaginating,
  } = useContext(RestaurantContext);
  let {
    foodForPOS,
    propertyItemList,
  } = useContext(FoodContext);

  // States hook here
  //new customer
  //search result
  let [searchedRecipe, setSearchedRecipe] = useState({
    list: null,
    searched: false,
  });
  const searchInputRef = useRef(null);
  const recipeImportInputRef = useRef(null);

  let [itemMapping,setItemMapping] = useState({
    id: null,
    item: null,
    property: null,
    uploading:false,
    modal: false,
  });

  const customStyles = {
    ///.....
    menuPortal: provided => ({ ...provided, zIndex: 9999 }),
    ///.....
  }
  
  //search purchase here
  const handleSearch = (e) => {
    let searchInput = e.target.value.toLowerCase();
    if (searchInput.length === 0) {
      setSearchedRecipe({ ...searchedRecipe, searched: false });
    } else {
      let searchedList = recipeForSearch?.filter((item) => {
        //name
        let lowerCaseRecipeName = item.item_name.toLowerCase();

        return (
          lowerCaseRecipeName.includes(searchInput)
        );
      });
      setSearchedRecipe({
        ...searchedRecipe,
        list: searchedList,
        searched: true,
      });
    }
  };

  const handleItemChange = (item) => {
    setItemMapping({
      ...itemMapping,
      item: item,
    })
  }

  useEffect(() => {
    handleFetchData(1)
  },[]);

  const handlePropertyChange = (property) =>{
    setItemMapping({
      ...itemMapping,
      property: property,
    })
  }

  // item mapping in recipe
  const handleSaveRecipe = (e) =>{
    e.preventDefault();
    if((itemMapping.item && itemMapping.item?.length > 0) || (itemMapping.property && itemMapping.property?.length > 0)){
     
    let itemId = [];
    let prpId = [];

    itemMapping.item && itemMapping.item.forEach((item)=>{
      itemId.push(item.id)
    });

    itemMapping.property && itemMapping.property.forEach((property)=>{
      prpId.push(property.id)
    });

    let formData = {
      recipe_id: itemMapping.id,
      item: JSON.stringify(itemId),
      property: JSON.stringify(prpId),
    }
    const url = BASE_URL + "/settings/recipeItem";
    return axios
      .post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
         setItemMapping({
          id: null,
          item: null,
          property: null,
          uploading:false,
          modal: false,
         })
        toast.success(`${_t(t("Recipe has been linked"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        setLoading(false)
      })
      .catch((err)=>{
        setItemMapping({
          ...itemMapping,
          uploading:false,
         })
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        setLoading(false)
      })
    }else{
      toast.error("Please select atleast one item or property");
      return false
    }
    
  }

  //delete confirmation modal of waiter
  const handleDeleteConfirmation = (id) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="card card-body">
            <h1>{_t(t("Are you sure?"))}</h1>
            <p className="text-center">{_t(t("You want to delete this?"))}</p>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-primary"
                onClick={() => {
                  handleDeleteRecipe(id);
                  onClose();
                }}
              >
                {_t(t("Yes, delete it!"))}
              </button>
              <button className="btn btn-success ml-2 px-3" onClick={onClose}>
                {_t(t("No"))}
              </button>
            </div>
          </div>
        );
      },
    });
  };

  // mappping set states
  const handleMapping = (item) => {
    setLoading(true)
    const url = BASE_URL + `/settings/recipeItem/${item.id}`;
    return axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        const foodItem = [];
        const property = [];
        res.data && res.data?.length && res.data.map(item =>{
           if(item.item_type === "FoodItem"){
            let food = foodForPOS.find(itm => itm.id === item.item_id);
            foodItem.push(food)
           }else{
            let propertyItem = propertyItemList.find(itm => itm.id === item.item_id);
            property.push(propertyItem)
           }
         })
         setItemMapping({
          ...itemMapping,
          id: item.id,
          item: foodItem?.length ? foodItem : null,
          property: property?.length ? property : null,
          modal: true,
         })
        setLoading(false)
      })
      .catch((err)=>{
        setItemMapping({
          ...itemMapping,
          id: item.id,
          item: null,
          property: null,
          modal: true,
         });
        setLoading(false)
      })

  }
  
  //delete purchase here
  const handleDeleteRecipe = async (id) => {
    setLoading(true);
    const url = BASE_URL + `/settings/recipe/${id}`;
    try {
      const res = await axios
      .delete(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setRecipeList(res.data[0]);
      setRecipeForSearch(res.data[1]);
      setSearchedRecipe({
        ...searchedRecipe,
        list: res.data[1],
      });
      setLoading(false);
      toast.success(`${_t(t("Recipe has been deleted successfully"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    } catch {
      setLoading(false);
      toast.error(`${_t(t("Please try again"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  };

  //toggle recipe status
  const handleToggleRecipeStatus = async (id, status) => {
    setLoading(true);
    const url = BASE_URL + `/settings/update-receipe-status`;
    try {
      const res = await axios
      .post(url, {
        id: id,
        status: status,
      },{
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setRecipeList(res.data[0]);
      setRecipeForSearch(res.data[1]);
      setSearchedRecipe({
        ...searchedRecipe,
        list: res.data[1],
      });
      setLoading(false);
      toast.success(`${_t(t("Recipe status has been updated successfully"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    } catch {
      setLoading(false);
      toast.error(`${_t(t("Please try again"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  };

  const handleFetchData = (page) => {
    setPaginatedRecipeList(page);
  };

  const COLUMNS = [
    {
      label: "S/L",
      render: (item, index) =>
        searchedRecipe.searched
          ? index + 1
          : index + 1 + ((recipeList?.current_page || 1) - 1) * (recipeList?.per_page || 0),
    },
    { label: "Recipe Type", key: "type" },
    { label: "Recipe Item", render: (item) => item.item_name || "--" },
    {
      label: "Created At",
      render: (item) =>
        item.created_at ? (
          <Moment format="DD-MMMM-YYYY hh:mm A">{item.created_at}</Moment>
        ) : (
          "--"
        ),
    },
    {
      label: "Updated At",
      render: (item) =>
        item.updated_at ? (
          <Moment format="DD-MMMM-YYYY hh:mm A">{item.updated_at}</Moment>
        ) : (
          "--"
        ),
    },
    { label: "Remarks", render: (item) => item.remarks || "--" },
    // {
    //   label: "Status", render: (item) => <span className="text-center">
    //     <Switch
    //       checked={item?.status === 1}
    //       onChange={() => handleToggleRecipeStatus(item.id, item.status ? 0 : 1)}
    //       height={20}
    //       width={40}
    //     />
    //   </span>
    // },
    {
      label: "Action",
      minWidth: "160px",
      render: (item) => (
        <div className="d-flex justify-content-center">
          <NavLink
            title="edit"
            to={`/dashboard/manage/stock/recipe-edit/${item.id}`}
            className="btn btn-primary ml-2 rounded-sm del-btn"
          >
            <i className="fa fa-pencil"></i>
          </NavLink>

          <NavLink
            title="duplicate recipe"
            to={`/dashboard/manage/stock/recipe-edit/${item.id}?duplicate=1`}
            className="btn btn-success ml-2 rounded-sm del-btn"
          >
            <i className="fa fa-clone"></i>
          </NavLink>

          {item.type !== "Sub Recipe" && (
            <button
              title="item mapping"
              className="btn btn-secondary ml-2 rounded-sm del-btn"
              onClick={() => handleMapping(item)}
            >
              <i className="fa fa-link"></i>
            </button>
          )}
        </div>
      ),
    },
  ];

  const getListData = useCallback(() => {
    if (searchedRecipe.searched) {
      return searchedRecipe.list || [];
    }

    return recipeList?.data || [];
  }, [searchedRecipe, recipeList]);

  const onClearSearch = () => {
    setSearchedRecipe({ ...searchedRecipe, searched: false });
    if (searchInputRef.current) {
      searchInputRef.current.value = "";
    }
  };

  const generateRecipeCsv = (data, filename) => {
    const csvExporter = new ExportToCsv({
      fieldSeparator: ",",
      quoteStrings: "\"",
      decimalSeparator: ".",
      showLabels: true,
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      filename,
    });

    csvExporter.generateCsv(data);
  };

  const handleExportRecipeData = () => {
    setLoading(true);
    const url = BASE_URL + "/settings/export-recipe";

    return axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        generateRecipeCsv(Array.isArray(res.data) ? res.data : [res.data], "Recipe Data");
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        ToastError({title: `${_t(t("Please try again"))}`});
      });
  };

  const handleDownloadRecipeTemplate = () => {
    const template = [
      "Id,Type,Item Name,Variation,Order Types,Ingredient Name,Unit Name,Ingredient Qty,Remarks",
      ",item,chesse pizza,,\"Dine-In, Delivery, Takeaway\",tomato,gram,20,",
      ",,,,\"Dine-In, Delivery, Takeaway\",onion,gram,30,",
      ",,,,\"Dine-In, Delivery, Takeaway\",Bun,pieces,20,",
      ",,,,\"Dine-In, Delivery, Takeaway\",salt,gram,1,",
      ",,,,\"Dine-In, Delivery, Takeaway\",Eggs,pieces,20,",
      ",Property,Pepsi,,\"Dine-In, Delivery, Takeaway\",potato,gram,100,",
      ",Sub Recipe,tomato,,\"Dine-In, Delivery, Takeaway\",onion,gram,10,",
      ",,,,\"Dine-In, Delivery, Takeaway\",salt,gram,5,",
      ",,,,\"Dine-In, Delivery, Takeaway\",Eggs,pieces,4,",
    ].join("\n");

    const blob = new Blob([template], { type: "text/csv;charset=utf-8;" });
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", "Recipe Template.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);
  };

  const parseRecipeCsvLine = (line) => {
    const values = [];
    let value = "";
    let isQuoted = false;

    for (let i = 0; i < line.length; i += 1) {
      const char = line[i];
      const nextChar = line[i + 1];

      if (char === "\"" && isQuoted && nextChar === "\"") {
        value += "\"";
        i += 1;
      } else if (char === "\"") {
        isQuoted = !isQuoted;
      } else if (char === "," && !isQuoted) {
        values.push(value);
        value = "";
      } else {
        value += char;
      }
    }

    values.push(value);
    return values.map((item) => item.replace(/^\uFEFF/, "").trim());
  };

  const readRecipeCsvFile = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsText(file, "UTF-8");
      fileReader.onload = (event) => resolve(event.target.result || "");
      fileReader.onerror = () => reject(new Error("Unable to read file"));
    });
  };

  const CSV_LENGTH = 9;

    // Check if the uploaded content is in valid CSV format
    function isCSV(contents) {
      // Basic check if it's a CSV file by checking if it contains a comma
      const rows = contents.split('\n');
  
      // Extract the header row (assuming it's the first row)
      const headerRow = rows[0];
  
      // Split the header row into individual header values
      const headers = headerRow.split(',');
      return contents.includes(',') && contents.includes('\n') && (headers.length === CSV_LENGTH);
    }

  const handleRecipeImportFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      const isCsvFile = file.name.toLowerCase().endsWith(".csv");

      if (!isCsvFile) {
        ToastError({ title: _t(t("Please upload a valid CSV file")) });
        return;
      }

      const contents = String(await readRecipeCsvFile(file)).replace(/^\uFEFF/, "");

      if (!isCSV(contents)) {
        ToastError({ title: _t(t("Please upload a valid CSV file")) });
        return;
      }

      const rows = contents
        .split(/\r?\n/)
        .map((row) => row.trim())
        .filter((row) => row !== "");
      const expectedHeaders = [
        "id",
        "type",
        "item_name",
        "variation",
        "order_types",
        "ingredient_name",
        "unit_name",
        "ingredient_qty",
        "remarks",
      ];
      const headers = parseRecipeCsvLine(rows[0] || "").map((header) =>
        header.toLowerCase().replace(/\s+/g, "_")
      );
      const isValidTemplate =
        headers.length === expectedHeaders.length &&
        expectedHeaders.every((header, index) => headers[index] === header);

      if (!isValidTemplate) {
        ToastError({ title: _t(t("Please upload valid recipe template CSV")) });
        return;
      }

      const payload = rows.slice(1).map((row) => {
        const values = parseRecipeCsvLine(row);
        const id = values[0];

        return {
          id: id ? Number(id) || id : null,
          type: values[1] || "",
          item_name: values[2] || "",
          variation: values[3] || "",
          remarks: values[8] || "",
          order_types: values[4] || "",
          ingredient_name: values[5] || "",
          unit_name: values[6] || "",
          ingredient_qty: values[7] || "",
        };
      });

      if (!payload.length) {
        ToastError({ title: _t(t("Please upload CSV with recipe rows")) });
        return;
      }

      setLoading(true);
      const res = await axios.post(BASE_URL + "/settings/import-recipe", payload, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });

      if (res.data?.success === false) {
        const errors = Array.isArray(res.data?.errors)
          ? res.data.errors.join("\n")
          : res.data?.message;
        ToastError({
          title: errors || _t(t("Validation failed")),
        });
        return;
      }

      handleFetchData(recipeList?.current_page || 1);
      ToastSuccess({title: `${_t(t(res.data?.message || "Recipes imported successfully"))} (${_t(t("Updated"))}: ${res.data?.updated || 0}, ${_t(t("Created"))}: ${res.data?.created || 0}, ${_t(t("Total"))}: ${res.data?.total_processed || payload.length})`});
    } catch (err) {
      console.log(err);
      const errors = err?.response?.data?.errors;
      ToastError({
        title: Array.isArray(errors)
          ? errors.join("\n")
          : err?.response?.data?.message || _t(t("Please try again")),
      });
    } finally {
      setLoading(false);
      if (recipeImportInputRef.current) {
        recipeImportInputRef.current.value = "";
      }
    }
  };

  return (
    <>
      <Helmet>
        <title>{_t(t("Recipes"))}</title>
      </Helmet>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div className="t-pl-15 t-pr-15">

                  <div key="fragment3">

                  <div className="row align-items-center t-pt-15 t-pb-15">
                      <div className="col-md-3">
                        <ul className="t-list fk-breadcrumb mb-0">
                          <li className="fk-breadcrumb__list">
                            <span className="t-link fk-breadcrumb__link text-capitalize">
                              {_t(t("Recipe List"))}
                            </span>
                          </li>
                        </ul>
                      </div>

                      <div className="col-md-9">
                        <div className="d-flex flex-wrap justify-content-md-end align-items-center gap-2">

                           {/* Export */}
                           <button
                            title="Download recipe data"
                            className="btn btn-success btn-sm text-uppercase sm-text rounded"
                            type="button"
                            disabled={loading || dataPaginating}
                            onClick={handleExportRecipeData}
                          >
                           <FaFileExport/> {_t(t("Export Data"))} 
                          </button>

                          {/* Template */}
                          <button
                            title="Download recipe import template"
                            className="btn btn-info btn-sm text-uppercase sm-text rounded"
                            type="button"
                            disabled={loading || dataPaginating}
                            onClick={handleDownloadRecipeTemplate}
                          >
                            {_t(t("Template CSV"))} <i className="fa fa-file-text-o"></i>
                          </button>

                          {/* Import */}
                          <button
                            title="Upload recipe CSV"
                            className="btn btn-primary btn-sm text-uppercase sm-text rounded"
                            type="button"
                            disabled={loading || dataPaginating}
                            onClick={() => recipeImportInputRef.current?.click()}
                          >
                            <FaFileImport/> {_t(t("Import CSV"))} 
                          </button>

                          <input
                            type="file"
                            accept=".csv"
                            className="d-none"
                            ref={recipeImportInputRef}
                            onChange={handleRecipeImportFile}
                          />

                          {/* Search */}
                          <div className="input-group" style={{ maxWidth: "360px" }}>
                            <input
                              type="text"
                              className="form-control border-0 form-control--light-1"
                              placeholder={_t(t("Search")) + ".."}
                              onChange={handleSearch}
                              ref={searchInputRef}
                              disabled={loading || dataPaginating}
                            />
                            <button className="btn btn-primary rounded" type="button">
                              <i className="fa fa-search" aria-hidden="true"></i>
                            </button>
                          </div>

                          {/* Add New */}
                          <NavLink
                            to="/dashboard/manage/stock/create-recipe"
                            className="btn btn-primary xsm-text text-uppercase rounded py-2"
                          >
                            {_t(t("add new"))}
                          </NavLink>

                         
                        </div>
                      </div>
                    </div>

                    
                    <DataTable
                      loading={loading || dataPaginating}
                      data={getListData()}
                      columns={COLUMNS}
                      emptyText="No data available"
                      pagination={{
                        isPageLoading: loading,
                        isPagination: true,
                        pageCount: recipeList?.last_page,
                        currentPage: recipeList?.current_page,
                        from: recipeList?.from,
                        to: recipeList?.to,
                        total: recipeList?.total,
                      }}
                      handleFetchData={handleFetchData}
                      searchPayload={{
                        isSearched: searchedRecipe.searched,
                        onClearSearch,
                      }}
                      theadClass="fk-scroll--2--pos-table"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Rightbar contents end*/}
          </div>
        </div>
        <div>

        {/* item map modal */}
        <div
        className={`modal fade ${
        itemMapping.modal === true ? "showing" : ""
        }`}
        aria-hidden="true">
        <div className="modal-dialog modal-lg itemMapping">
          <div className="modal-content">
            <div className="modal-header align-items-center">
                <div className="fk-sm-card__content">
                <h5 className="fk-sm-card__title">
                    Item Mapping
                </h5>
                </div>
                <button
                type="button"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => {
                    setItemMapping({
                    ...itemMapping,
                    modal: false
                    })
                }}
                ></button>
            </div>
            
            <div className="modal-body">

                {/* show form or show saving loading */}
                {itemMapping.uploading === false ? (
                <div key="fragment-food-group-1">
                    <form onSubmit={handleSaveRecipe} className="mx-2" autoComplete="off">
                    <div className= "pr-1 m-1 recipe_height">
                     <div className="row">
                      <div className="form-group mt-3 col-6">
                      <div className="mb-2">
                        <label
                          htmlFor="items"
                          className="control-label"
                        >
                          {_t(t("Items"))}
                        </label>
                      </div>
                        <Select
                          isMulti
                          menuPlacement={ itemMapping.item?.length > 5 ? "top" : "bottom" }
                          options={foodForPOS}
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.id}
                          classNamePrefix="select"
                          onChange={handleItemChange}
                          value={itemMapping.item}
                          styles={customStyles}
                          menuPortalTarget={document.body}
                          maxMenuHeight="12rem"
                          menuPosition="fixed"
                          placeholder={
                            _t(t("Please Select Item")) + ".."
                          }
                        />
                      </div>

                      <div className="form-group mt-3 col-6">
                      <div className="mb-2">
                        <label
                          htmlFor="item"
                          className="control-label"
                        >
                          {_t(t("Properties"))}
                        </label>
                      </div>
                        <Select
                        isMulti
                        menuPlacement={ itemMapping.property?.length > 5 ? "top" : "bottom" }
                        options={propertyItemList}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}
                        classNamePrefix="select"
                        onChange={handlePropertyChange}
                        value={itemMapping.property}
                        styles={customStyles}
                        menuPortalTarget={document.body}
                        maxMenuHeight="12rem"
                        menuPosition="fixed"
                        placeholder={
                          _t(t("Please Select property")) + ".."
                        }
                      />
                      </div>
                     
                     </div>
                    </div>
                    <div className="row  my-4">
                      <div className="col-10"></div>
                      <div className="col-2 pr-4">
                        <button
                            disabled={loading}
                            type="submit"
                            className="btn btn-primary col-12 table-text text-uppercase rounded"
                        >
                            {_t(t("Save"))}
                        </button>
                      </div>
                    </div>
                    </form>
                </div>
                ) : (
                <div key="fragment2">
                    <div className="text-center text-primary font-weight-bold text-uppercase">
                    {_t(t("Please wait"))}
                    </div>
                    {modalLoading(5)}
                </div>
                )}
            </div>
           </div>
         </div>
      </div>

    </div>
      </main>
      {/* main body ends */}
    </>
  );
};

export default ViewRecipe;
